module.exports = {
  // 活动时间线
  timeLine: {
    statusA: {
      start: new Date('2026/01/01 13:00:00 GMT+8').getTime()
    }
  }
};